import * as React from 'react';
import { st, classes } from './CheckboxGroup.deprecated.st.css';
import { Fieldset } from '../internal/Fieldset';
import { CheckboxGroupLayout, } from './types';
import uniqueId from '../../common/uniqueId';
class CheckboxGroup extends React.Component {
    constructor(props) {
        super(props);
        this._errorMessageId = uniqueId('error-message');
    }
    render() {
        const { label, layout, error, disabled, errorText, className, newErrorMessage, fluid, } = this.props;
        const stStates = { disabled, layout, error, newErrorMessage, fluid };
        const isErrorMessageProvided = errorText && errorText.length > 0;
        return (React.createElement(Fieldset, { errorMessage: newErrorMessage && error && errorText, errorMessageId: this._errorMessageId, "data-hook": this.props['data-hook'], className: st(classes.root, stStates, className), label: label },
            React.createElement("div", { className: classes.wrapper }, React.Children.map(this.props.children, (child, idx) => {
                if (!React.isValidElement(child)) {
                    return null;
                }
                return (React.createElement(React.Fragment, null, React.cloneElement(child, {
                    key: idx,
                    error,
                    disabled,
                    className: st(classes.checkboxItem, child.props.className),
                })));
            })),
            error && isErrorMessageProvided && !disabled && !newErrorMessage && (React.createElement("span", { className: classes.error }, errorText))));
    }
}
CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.defaultProps = {
    layout: CheckboxGroupLayout.Vertical,
};
export { CheckboxGroup };
//# sourceMappingURL=CheckboxGroup.js.map